export const totalNotiUnreadSelector = (state: any) => state.notificationReducer.totalNotiUnread;